export const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : 'https://127.0.0.1:8000'

const CARS_URL = 'cars'
const PRICING_URL = 'pricing'
const DEALS_URL = 'deals'
const LEADS_URL = 'leads'
const CLIENTS_URL = 'clients'
const EMAILS_URL = 'emails'
const ACCOUNTS_URL = 'accounts'

const CREATE_URL = 'create'
const UPDATE_URL = 'update'
const DELETE_URL = 'delete'

export const URLS = {
    getCSRFCookie: () => `/get_csrf_cookie`,
    logError: () => `/log_error`,
    checkVersion: () => `/check_version`,

    // Accounts URLS
    login: () =>  `/accounts/login`,
    logout: () => `/accounts/logout`,
    changePassword: () => `/accounts/change_password`,
    refreshToken: () => `/accounts/token/refresh`,
    // Default Quote Settings
    getDefaultQuoteSettings: () => `/${ACCOUNTS_URL}/quote_settings`,
    updateDefaultQuoteSettings: () => `/${ACCOUNTS_URL}/quote_settings/update`,


    //CAR URLS
    makesForYear: (isUsed) => `/${CARS_URL}/?is_used=${isUsed}`,
    modelsForMake: (year, make, isUsed) => `/${CARS_URL}/${year}/${make}/?is_used=${isUsed}`,
    trimsForModel: (year, make, model, isUsed) => `/${CARS_URL}/${year}/${make}/${model}/?is_used=${isUsed}`,
    getCarByVin: (vin, isUsed) => `/${CARS_URL}/${vin}/?is_used=${isUsed}`,

    // PRICING URLS
    getPricingsForMake: (make, params) => params ? `/${PRICING_URL}/${make}?${params}` : `/${PRICING_URL}/${make}`,
    createPricing: (make) => `/${PRICING_URL}/${CREATE_URL}`,
    updatePricing: (id) => `/${PRICING_URL}/${id}/${UPDATE_URL}`,
    deletePricing: (id) => `/${PRICING_URL}/${id}/${DELETE_URL}`,

    // DEAL URLS
    getDeal: (id, params) => params ? `/${DEALS_URL}/${id}?${params}` : `/${DEALS_URL}/${id}`,
    getDeals: (params) => params ? `/${DEALS_URL}?${params}` : `/${DEALS_URL}`,
    createDeal: () => `/${DEALS_URL}/${CREATE_URL}`,
    updateDeal: (id) => `/${DEALS_URL}/${id}/${UPDATE_URL}`,
    deleteDeal: (id) => `/${DEALS_URL}/${id}/${DELETE_URL}`,
    getPDF: (id) => `/${DEALS_URL}/${id}/pdf`,

    // Desking
    getDesking: () => `/${DEALS_URL}/desking`,
    getRebates: () => `/${DEALS_URL}/rebates`,
    getRebateCompatibilities: () => `/${DEALS_URL}/rebate_compatibilities`,
    getRebate: (rebateId) => `/${DEALS_URL}/get_rebate/${rebateId}`,

    // PROFILE URLS
    // Location
    getProfile: () => `/accounts/profile`,
    updateProfile: () => `/accounts/profile/update`,
    getLocations: () => `/accounts/locations`,
    createLocation: () => `/accounts/location`,
    updateLocation: (id) => `/accounts/location/${id}/${UPDATE_URL}`,
    deleteLocation: (id) => `/accounts/location/${id}`,

    // Leads
    getLead: (id, params) => params ? `/${LEADS_URL}/${id}?${params}` : `/${LEADS_URL}/${id}`,
    getLeads: (params) => params ? `/${LEADS_URL}?${params}` : `/${LEADS_URL}`,
    createLead: () => `/${LEADS_URL}/${CREATE_URL}`,
    updateLead: (id) => `/${LEADS_URL}/${id}/${UPDATE_URL}`,
    deleteLead: (id) => `/${LEADS_URL}/${id}/${DELETE_URL}`,
    uploadLeadsCSV: () => `/${LEADS_URL}/upload_csv`,
    bulkUploadLeads: () => `/${LEADS_URL}/bulk_upload`,

    // Clients
    getClient: (id, params) => params ? `/${CLIENTS_URL}/${id}?${params}` : `/${CLIENTS_URL}/${id}`,
    getClients: (params) => params ? `/${CLIENTS_URL}?${params}` : `/${CLIENTS_URL}`,
    createClient: () => `/${CLIENTS_URL}/${CREATE_URL}`,
    updateClient: (id) => `/${CLIENTS_URL}/${id}/${UPDATE_URL}`,
    deleteClient: (id) => `/${CLIENTS_URL}/${id}/${DELETE_URL}`,
    bulkUploadClients: () => `/${CLIENTS_URL}/bulk_upload`,

    // Emails
    createEmail: () => `/${EMAILS_URL}/${CREATE_URL}`,
}